import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import * as properties from '../../../constants/Properties'
import { setSplitReceiptModal, splitReceiptModalAddLineRight, splitReceiptModalAddLineLeft } from '../../actions/modalActions.js'
import SplitReceiptModalLeftReceipt from './SplitReceiptModalLeftReceipt'
import SplitReceiptModalRightReceipt from './SplitReceiptModalRightReceipt'
import PropTypes from 'prop-types'

class SplitReceiptModal extends Component {
    constructor(props) {
        super(props);
        this.handleLeftReceiptTap = this.handleLeftReceiptTap.bind(this);
        this.handleRightReceiptTap = this.handleRightReceiptTap.bind(this);
        this.confirmTap = this.confirmTap.bind(this);
    }
    
    handleLeftReceiptTap(lineid) {
        this.props.splitReceiptModalAddLineRight(lineid);
    }

    handleRightReceiptTap(lineid) {
        this.props.splitReceiptModalAddLineLeft(lineid);
    }

    confirmTap() {
        const confirm = this.props.confirm;
        const receiptleft = this.props.receiptlinesleft;
        const receiptright = this.props.receiptlinesright;
        const params = [receiptleft, receiptright];
        this.props.dispatch(confirm.apply(this, params)); 
        this.props.setSplitReceiptModal(false, receiptleft, receiptright, null);
    }

    render() {     
        return (
            <Modal className='splitReceiptModal'            
                contentLabel=""
                isOpen={this.props.receiptModal.show}
                style={properties.splitReceiptModalStyle}
                >
                <div className="splitReceiptModal_content">
                    <div className="splitReceiptModal_wrapper">
                        <SplitReceiptModalLeftReceipt 
                            receiptlines={this.props.receiptlinesleft}
                            callback={this.handleLeftReceiptTap}
                        />
                        <SplitReceiptModalRightReceipt
                            receiptlines={this.props.receiptlinesright}
                            callback={this.handleRightReceiptTap}
                            confirm={this.confirmTap}
                            confirmbuttontext={this.props.confirmbuttontext}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}

SplitReceiptModal.propTypes = {
    receiptModal: PropTypes.object.isRequired,
    setSplitReceiptModal: PropTypes.func.isRequired,
    splitReceiptModalAddLineRight: PropTypes.func.isRequired,
    splitReceiptModalAddLineLeft: PropTypes.func.isRequired,
    confirm: PropTypes.func
}

function mapStateToProps(state) {
    return {
        receiptModal: state.modalState.splitReceiptModal,
        receiptlinesleft: state.modalState.splitReceiptModal.receiptlinesleft,
        receiptlinesright: state.modalState.splitReceiptModal.receiptlinesright,
        confirm: state.modalState.splitReceiptModal.confirm,
        dispatch: state.modalState.splitReceiptModal.dispatch,
        confirmbuttontext: state.modalState.splitReceiptModal.confirmbuttontext
    }
}

export default connect(mapStateToProps, { setSplitReceiptModal, splitReceiptModalAddLineRight, splitReceiptModalAddLineLeft })(SplitReceiptModal)


// WEBPACK FOOTER //
// src/modal/components/SplitReceiptModal/SplitReceiptModal.jsx